import { UpdateWorkRequestType } from '@commenda/types/src/work-request/types';
import { fetcher } from '@commenda/utils';

export async function updateWorkRequest<T>({
  data,
  token,
  workRequestId,
}: {
  data: UpdateWorkRequestType & { requestData?: T };
  token?: string;
  workRequestId: string;
}): Promise<boolean> {
  try {
    const res = await fetcher(
      `workRequest/${workRequestId}`,
      {
        method: 'POST',
        body: data,
      },
      token
    );
    if (!res.ok) return false;
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}
